// extracted by mini-css-extract-plugin
module.exports = {"pg-course__filter":"styles_pg-course__filter__22pIU","pg-course__filter__actions":"styles_pg-course__filter__actions__3alyC","pg-course__table":"styles_pg-course__table__1PmgX"};